module.exports = __webpack_public_path__ + "img/flip-backward.9d7b762b.svg";